import { render, staticRenderFns } from "./InventoryHistoryTables.vue?vue&type=template&id=1233481a&"
import script from "./InventoryHistoryTables.vue?vue&type=script&lang=js&"
export * from "./InventoryHistoryTables.vue?vue&type=script&lang=js&"
import style0 from "./InventoryHistoryTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports